import { SET_AUTH, PURGE_AUTH, SET_ERROR, PURGE_ERROR } from "./mutations.type";

const state = {
  errors: null,
  user: null,
  isAuthenticated: false
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },

  [PURGE_ERROR](state) {
    state.errors = null;
  },

  [SET_AUTH](state, payload) {
    if (
      !payload ||
      !payload.idToken ||
      !payload.idToken.jwtToken
    ) {
      state.user = null;
      state.isAuthenticated = false;
      return;
    }

    // ★ Amplify Session 互換形に正規化（Optional Chaining 不使用）
    state.user = {
      idToken: {
        jwtToken: payload.idToken.jwtToken,
        payload: payload.idToken.payload || {}
      },
      accessToken: {
        jwtToken:
          payload.accessToken && payload.accessToken.jwtToken
            ? payload.accessToken.jwtToken
            : ""
      },
      refreshToken: {
        token:
          payload.refreshToken && payload.refreshToken.token
            ? payload.refreshToken.token
            : ""
      }
    };

    state.isAuthenticated = true;
  },

  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = null;
    state.errors = null;
  }
};

export default {
  state,
  mutations,
  getters
};
